import * as React from "react";
import { UitkCardAloha, UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkImage, UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkButton, UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon } from "uitk-react-icons";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { useLocalization } from "@shared-ui/localization-context";
import { MapMarkerCardProps, MapMarkerCardViewProps } from "../typings";
import { MarkerIcon } from "../markers/MapMarkers";

import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { Action, sendImmediateTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);

export const MAP_CARD_ID = "dx-map-card";
export const MAP_CARD_IMAGE_ID = "dx-map-card-image";
const moduleName = "MapMarkerCard";

export const MapMarkerCard = (props: MapMarkerCardProps) => {
  return (
    <Viewport>
      <ViewSmall>
        <MapMarkerCardView showCard={props.showCard} onClose={props.onClose} content={props.content} isMobile={true} />
      </ViewSmall>
      <ViewLarge>
        <MapMarkerCardView showCard={props.showCard} onClose={props.onClose} content={props.content} isMobile={false} />
      </ViewLarge>
    </Viewport>
  );
};

const MapMarkerCardView = (props: MapMarkerCardViewProps) => {
  const { formatText } = useLocalization();
  const cardClasses = props.isMobile ? "map-card" : "map-card map-card--desktop";

  const closeMapMarkerCard = () => {
    const trackingInfo = {
      moduleName,
      action: Action.CLICK,
      rfrr: "mapMarker.close",
    };

    sendImmediateTrackEvent(trackingInfo, props.analytics);
    props.onClose();
  };

  const priceText = () => {
    const { price, type } = props.content;

    if (!price) {
      return null;
    }

    if (!(type === MarkerIcon.HOTEL || type === MarkerIcon.ACTIVITY)) {
      return null;
    }

    const textToDisplay =
      type === MarkerIcon.HOTEL
        ? formatText("destinationDiscoveryMap.hotel.price", price)
        : formatText("destinationDiscoveryMap.activity.price", price);

    return (
      <UitkCardAlohaContentSection border="bottom">
        <UitkText size={500} weight="medium" align="right">
          {textToDisplay}
        </UitkText>
      </UitkCardAlohaContentSection>
    );
  };

  return (
    <div id={MAP_CARD_ID} className={props.showCard ? `${cardClasses} map-card--reveal` : cardClasses}>
      <UitkCardAloha>
        <UitkLayoutFlex direction="column">
          <UitkCardAlohaContentSection border="bottom">
            <UitkLayoutFlex justifyContent="space-between" alignItems="center">
              <UitkHeading size={500} level={2}>
                {props.content.title}
              </UitkHeading>
              <UitkSpacing padding="one">
                <UitkButton
                  title={formatText("destinationDiscoveryMap.button.card.close")}
                  onClick={closeMapMarkerCard}
                >
                  <UitkIcon name="close" />
                </UitkButton>
              </UitkSpacing>
            </UitkLayoutFlex>
          </UitkCardAlohaContentSection>

          {Boolean(props.content.photoUrl) && (
            <UitkFigure ratio={UitkFigureAspectRatioType.R16_9}>
              <UitkImage
                placeholderImage={true}
                alt={props.content.attribution?.attributionAltText || props.content.photoAlt}
                src={props.content.photoUrl}
              />
              {props.content.attribution?.attributionText}
            </UitkFigure>
          )}

          {priceText()}

          <UitkCardAlohaContentSection>
            <UitkLayoutFlex direction="column">
              <UitkText>{props.content.description}</UitkText>
              <UitkSpacing margin={{ blockstart: "three" }}>
                <ButtonTracked
                  moduleName="findHotel"
                  rfrr="map.marker"
                  linkName="RFRR Action Event"
                  text={props.content.buttonLabel}
                  icon={props.content.buttonIcon}
                  href={props.content.link}
                />
              </UitkSpacing>
            </UitkLayoutFlex>
          </UitkCardAlohaContentSection>
        </UitkLayoutFlex>
      </UitkCardAloha>
    </div>
  );
};

export default MapMarkerCard;
